import React, { useMemo } from 'react';
import DialogComponent from '@ui/components/Dialog/Dialog.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    loading,
    serverError,
    selectedSubuser,
    selectedDevice,
    devices,
    onConfirmClick,
    onBtnKeyDown,
    onCancelClick,
}: IProps) => {
    const getWord = useDictionary();

    const title = useMemo(() => {
        const [device] = devices.filter(({ imei }) => imei === selectedDevice);
        return `${getWord('confirmDeviceDeleteWarning')} "${
            device?.name
        }" ${getWord('fromSubuser').toLowerCase()} "${selectedSubuser}"`;
    }, [devices, selectedDevice, selectedSubuser, lang]);

    return (
        <>
            <DialogComponent
                className="device-delete"
                alertText={serverError ? 'serverError' : undefined}
                loading={loading}
                lang={lang}
                title={title}
                onConfirmClick={onConfirmClick}
                onCancelClick={onCancelClick}
                onBtnKeyDown={onBtnKeyDown}
            />
        </>
    );
};

const DeviceDeleteComponent = React.memo(Component);

export default DeviceDeleteComponent;
